module.exports = __webpack_public_path__ + "public/assets/img/forgot-password-v2.9faba3c1.svg";